import { subscriptionApi } from '@/api/subscription.api';
import { Store } from 'vuex';
import {
  ExtendUserProductSubscriptionPayload,
  SubscriptionState
} from './subscription.state';

export const subscriptionActions = {
  async getMySubscriptions(store: Store<SubscriptionState>) {
    try {
      store.commit('GET_MY_SUBSCRIPTION_LOADING');

      const { data } = await subscriptionApi.getMySubscriptions();
      store.commit('GET_MY_SUBSCRIPTION_SUCCESS', data);
    } catch (error) {
      store.commit('GET_MY_SUBSCRIPTION_ERROR', error);
    }
  },
  async extendUserProductSubscription(
    store: Store<SubscriptionState>,
    payload: ExtendUserProductSubscriptionPayload
  ) {
    try {
      store.commit('EXTEND_USER_PRODUCT_SUBSCRIPTION_LOADING');

      const { data } = await subscriptionApi.extendUserProductSubscription(
        payload
      );
      store.commit('EXTEND_USER_PRODUCT_SUBSCRIPTION_SUCCESS', data);
    } catch (error) {
      store.commit('EXTEND_USER_PRODUCT_SUBSCRIPTION_ERROR', error);
    }
  }
};
